import { ACCOUNT_LINKING_DETAILS, ACCOUNT_LINKING_DETAILS_SUCCESS, ACCOUNT_LINKING_DETAILS_FAILURE, CLEAR_ACCOUNT_LINKING_DETAILS_DATA } from '../actions/actionTypes'
const accountLinkReducer = (state = { data: null, isLoading: false, error: null }, actionPayload = { type: null, payload: null }) => {
  const { type, payload } = actionPayload
  switch (type) {
    case ACCOUNT_LINKING_DETAILS:
      return {
        ...state,
        status: null,
        isLoading: true
      }
    case ACCOUNT_LINKING_DETAILS_SUCCESS:
      return {
        ...state,
        data: payload,
        status: true,
        error: null,
        isLoading: false
      }
    case ACCOUNT_LINKING_DETAILS_FAILURE:
      return {
        ...state,
        status: false,
        error: payload,
        isLoading: false
      }
    case CLEAR_ACCOUNT_LINKING_DETAILS_DATA:
      return {
        ...state,
        error: null,
        status: null,
        isLoading: false,
        data: null
      }
    default:
      return state
  }
}

export default accountLinkReducer
